import { render, staticRenderFns } from "./Wp_login.vue?vue&type=template&id=0bd698ad&"
import script from "./Wp_login.vue?vue&type=script&lang=js&"
export * from "./Wp_login.vue?vue&type=script&lang=js&"
import style0 from "./Wp_login.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports